// extracted by mini-css-extract-plugin
export var sliderRange = "_p8-2";
export var sliderRoot = "_p8-0";
export var sliderThumb = "_p8-3";
export var sliderTrack = "_p8-1";